(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_header-menu"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const button = event.target.closest('[data-ln-nav-toggle]');
    if (!button) return;
    const root = button.closest('[data-navigation-bar-enabled]');
    const panel = document.getElementById(button.getAttribute('aria-controls'));
    if (!root || !panel) return;
    const open = button.getAttribute('aria-expanded') !== 'true';
    root.querySelectorAll('[data-ln-nav-toggle]').forEach((other) => {
      other.setAttribute('aria-expanded', 'false');
    });
    root.querySelectorAll('.ln-mobile-submenu').forEach((other) => { other.hidden = true; });
    button.setAttribute('aria-expanded', String(open));
    panel.hidden = !open;
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape' || !(event.target instanceof Element)) return;
    const root = event.target.closest('[data-navigation-bar-enabled]');
    const button = root?.querySelector('[data-ln-nav-toggle][aria-expanded="true"]');
    if (!button) return;
    document.getElementById(button.getAttribute('aria-controls')).hidden = true;
    button.setAttribute('aria-expanded', 'false');
    button.focus();
  });
  } catch(e) { console.error(e); }
})();

})();
